/// <reference no-default-lib="true"/>
/// <reference lib="WebWorker"/>
import { CacheGuard } from './cache-guard';
import { createCacheManager } from './cache-manager';
import { ResponseMeta } from './http-meta';

const endpointWhitelist = ['/achBanks'];

export enum PwaCache {
    Static = 'static',
    Runtime = 'runtime',
}

interface MessagePayload {
    version?: string;
    authToken?: string;
    apiRoot?: string;
}

/**
 * Aliases `self` mostly to enable better typing.
 */

const worker = self as unknown as ServiceWorkerGlobalScope;
const cm = createCacheManager(PwaCache, 'pwa', worker, endpointWhitelist);
const guard = new CacheGuard(worker, endpointWhitelist);
cm.getCache(PwaCache.Runtime).then(cache =>
    // eslint-disable-next-line no-console
    cache.keys().then(keys => console.log('Current SW runtime cache keys:', keys))
);
cm.getCache(PwaCache.Static).then(cache =>
    // eslint-disable-next-line no-console
    cache.keys().then(keys => console.log('Current SW static cache keys:', keys))
);

// The activate event occurs when a new version of the worker is invoked.
worker.addEventListener('activate', event => {
    event.waitUntil(cm.clearStaleCaches());
});

// DE: Temporarily disabling caching for all requests - 8-7-24
// worker.addEventListener('fetch', event => {
//     if (!guard.verifyRequest(event.request)) {
//         return;
//     }

//     event.respondWith(onCacheableFetch(event));
// });

worker.addEventListener('message', event => {
    const { version, authToken, apiRoot } = event.data as MessagePayload;

    if (version) {
        event.waitUntil(cm.setVersion(version));
    }

    if (authToken && apiRoot) {
        cm.cacheEndpoints(PwaCache.Runtime, apiRoot, authToken);
    }
});

// eslint-disable-next-line @typescript-eslint/no-unused-vars
async function tryCache(req: Request, res: Response) {
    const meta = new ResponseMeta(res);
    if (!guard.verifyResponse(res)) {
        return undefined;
    }

    const cache = meta.isJson
        ? await cm.getCache(PwaCache.Runtime)
        : await cm.getCache(PwaCache.Static);

    return cache.put(req, res.clone());
}
